module.exports = __webpack_public_path__ + "img/photo_220280568_1.afed0df2.png";